import _Toolbar from "@material-ui/core/esm/Toolbar";
import _Tooltip from "@material-ui/core/esm/Tooltip";
import _IconButton from "@material-ui/core/esm/IconButton";
import _Box from "@material-ui/core/esm/Box";
import _OutlinedInput from "@material-ui/core/esm/OutlinedInput";
import _InputAdornment from "@material-ui/core/esm/InputAdornment";
import _FormControl from "@material-ui/core/esm/FormControl";
import _Select from "@material-ui/core/esm/Select";
import _MenuItem from "@material-ui/core/esm/MenuItem";
import _Typography from "@material-ui/core/esm/Typography";
var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var defaultProps = type && type.defaultProps, childrenLength = arguments.length - 3; if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) { for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3]; props.children = childArray; } if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {}); return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null }; }

import React from 'react';
import { useIntl } from 'react-intl';
import { messages } from "../TableMessages";
import { tableToolbarProps } from "../types";
import SearchIcon from '@material-ui/icons/Search';
import DeleteIcon from '@material-ui/icons/Delete';
import { useStyles } from "./TableToolbarStyles";

var _ref = /*#__PURE__*/_jsx(_OutlinedInput, {});

var _ref3 = /*#__PURE__*/_jsx(DeleteIcon, {});

function TableToolbar(props) {
  const numSelected = props.numSelected,
        filteredValue = props.filteredValue,
        onFilter = props.onFilter,
        onChangeFilterBy = props.onChangeFilterBy,
        filterProperty = props.filterProperty,
        _props$filters = props.filters,
        filters = _props$filters === void 0 ? [] : _props$filters,
        onSelectItems = props.onSelectItems,
        tableToolbarStyles = props.tableToolbarStyles,
        selectedOptions = props.selectedOptions;
  const checkboxHidden = selectedOptions.checkboxHidden,
        selectedIcon = selectedOptions.selectedIcon,
        selectedTooltip = selectedOptions.selectedTooltip;

  const _useIntl = useIntl(),
        f = _useIntl.formatMessage;

  const classes = useStyles();
  const showFilters = filterProperty && filters.length > 0;
  return _jsx(_Toolbar, {
    className: "\n        ".concat(classes.root, " \n        ").concat(numSelected > 0 && classes.bgPrimary, " \n        ").concat(!showFilters && numSelected < 1 && classes.shortHeader, "\n        ").concat(tableToolbarStyles, "\n        ").concat(checkboxHidden && classes.checkboxHidden, "\n      ")
  }, void 0, numSelected > 0 ? _jsx(_Typography, {
    variant: "subtitle1",
    className: classes.selectedTitle
  }, void 0, numSelected, " ", f(messages.selectedTableItems)) : _jsx(_Box, {}, void 0, showFilters && _jsx(_Box, {
    className: classes.searchContainer
  }, void 0, _jsx(_FormControl, {}, void 0, _jsx(_Select, {
    id: "filterProperty",
    value: filterProperty,
    onChange: onChangeFilterBy,
    input: _ref,
    className: classes.filterProperty
  }, void 0, _jsx(_MenuItem, {
    value: "",
    disabled: true
  }, "option-disabled-1", f(messages.filterBy)), filters.map((_ref2, index) => {
    let key = _ref2.key,
        value = _ref2.value;
    return _jsx(_MenuItem, {
      value: key
    }, index, value);
  }))), _jsx(_OutlinedInput, {
    className: classes.searchStyle,
    value: filteredValue,
    onChange: onFilter,
    placeholder: "".concat(f(messages.searchBarPlaceholder)),
    startAdornment: _jsx(_InputAdornment, {
      position: "start"
    }, void 0, _jsx(SearchIcon, {
      className: classes.searchIcon,
      fontSize: "medium"
    }))
  }))), numSelected > 0 && _jsx(_Tooltip, {
    title: "".concat(f(selectedTooltip ? selectedTooltip : messages.deleteTooltip))
  }, void 0, _jsx(_IconButton, {
    onClick: onSelectItems
  }, void 0, selectedIcon ? selectedIcon : _ref3)));
}

export { TableToolbar };